var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32265 13C6.22108 12.9986 6.12084 12.9767 6.02801 12.9354C5.93519 12.8941 5.85171 12.8345 5.78265 12.76L0.952648 7.50997C0.817387 7.36277 0.74614 7.16788 0.754579 6.96815C0.763018 6.76842 0.850453 6.58023 0.997648 6.44497C1.14484 6.30971 1.33974 6.23846 1.53947 6.2469C1.73919 6.25534 1.92739 6.34277 2.06265 6.48997L6.34515 11.155L15.9601 1.22497C16.0291 1.15406 16.1113 1.09742 16.2022 1.05828C16.293 1.01915 16.3906 0.998294 16.4895 0.996901C16.5884 0.995508 16.6866 1.01361 16.7785 1.05017C16.8704 1.08672 16.9542 1.14103 17.0252 1.20997C17.0961 1.27891 17.1527 1.36115 17.1918 1.45198C17.231 1.54282 17.2518 1.64047 17.2532 1.73936C17.2546 1.83826 17.2365 1.93646 17.2 2.02836C17.1634 2.12026 17.1091 2.20406 17.0401 2.27497L6.86265 12.775C6.7923 12.8467 6.70825 12.9036 6.61549 12.9423C6.52273 12.9809 6.42314 13.0006 6.32265 13Z",
    fill: "#2A1B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4b3723a2fbafffd535011ec24368b1cb.svg";
export { ForwardRef as ReactComponent };